import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of, tap } from 'rxjs';
import { LoggerService } from '@pf/shared-services';
import { NativeBridgeService } from '../native-bridge.service';
import { NativeAppBarResult } from '../models/native-app-bar-result';
import { IS_CT_WEB_VIEW } from '../is-ct-web-view.token';

@Injectable({ providedIn: 'root' })
export class NativeAppBarService {
    private readonly logger = inject(LoggerService);
    private readonly nativeBridge = inject(NativeBridgeService);
    private readonly isWebView = inject(IS_CT_WEB_VIEW);

    /** Whether the Android-native app bar bridge is available in this runtime. */
    get canUseNativeAppBar(): boolean {
        return this.isWebView;
    }

    toggleVisibility(visible: boolean): Observable<boolean> {
        return this.nativeBridge
            .invoke<NativeAppBarResult>('toggleVisibility', callbackId =>
                window.CT_Native_AppBar?.toggleVisibility(visible, callbackId)
            )
            .pipe(
                tap(result => {
                    if (result.error) {
                        this.logger.error(
                            'Native AppBar Error: ' + result.error
                        );
                    }
                }),
                map(result => result.success),
                catchError(err => {
                    this.logger.error(
                        'Native AppBar toggleVisibility failed',
                        err
                    );
                    return of(false);
                })
            );
    }
}
